// extracted by mini-css-extract-plugin
export var carrierTab = "_3v-0";
export var carrierTabActive = "_3v-1 _3v-0";
export var carrierTabInactive = "_3v-2 _3v-0";
export var carrierTabLabel = "_3v-3";
export var carrierTabLabelActive = "_3v-4 _3v-3";
export var carrierTabLabelInactive = "_3v-5 _3v-3";
export var carrierTabPercentage = "_3v-6";
export var carrierTabPercentageActive = "_3v-7 _3v-6";
export var carrierTabPercentageInactive = "_3v-8 _3v-6";
export var carrierTabWinnable = "_3v-9";
export var carrierTabWinnableActive = "_3v-a _3v-9";
export var carrierTabWinnableInactive = "_3v-b _3v-9";
export var comparisonContainer = "_3v-d";
export var missingRateButton = "_3v-n";
export var missingRateButtonActive = "_3v-o _3v-n";
export var missingRateButtonInactive = "_3v-p _3v-n";
export var missingRateButtonLabel = "_3v-q";
export var missingRateButtonLabelActive = "_3v-r _3v-q";
export var missingRateButtonLabelInactive = "_3v-s _3v-q";
export var sidebar = "_3v-c";
export var strategyButton = "_3v-e";
export var strategyButtonActive = "_3v-f _3v-e";
export var strategyButtonDescription = "_3v-k";
export var strategyButtonDescriptionActive = "_3v-l _3v-k";
export var strategyButtonDescriptionInactive = "_3v-m _3v-k";
export var strategyButtonInactive = "_3v-g _3v-e";
export var strategyButtonLabel = "_3v-h";
export var strategyButtonLabelActive = "_3v-i _3v-h";
export var strategyButtonLabelInactive = "_3v-j _3v-h";
export var unitToggleButton = "_3v-t";
export var unitToggleButtonActive = "_3v-u _3v-t";
export var unitToggleButtonInactive = "_3v-v _3v-t";
export var unitToggleButtonLabel = "_3v-w";
export var unitToggleButtonLabelActive = "_3v-x _3v-w";
export var unitToggleButtonLabelInactive = "_3v-y _3v-w";